/**
 * Exchange rate announcement — driven by admin unified pricing when available.
 */
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { ThemedPageHeader } from '../components/ui/ThemedPageHeader';
import { THEMED_SURFACE_COLORS as C } from '../components/ui/ThemedSurface';

interface PublicPricing {
  lines_zh: string[];
  lines_en: string[];
}

export function ExchangeCalc() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const pricingQuery = useQuery({
    queryKey: ['pricing', 'public'],
    queryFn: () => api.get<PublicPricing>('/api/pricing/public'),
    staleTime: 60_000,
  });

  const lines =
    i18n.language.startsWith('zh')
      ? pricingQuery.data?.lines_zh ?? []
      : pricingQuery.data?.lines_en ?? [];

  return (
    <div className="relative min-h-full" style={{ background: C.pageBg }}>
      <div className="relative mx-auto min-h-full w-full max-w-[430px]">
        <ThemedPageHeader title={t('exchangeCalc.title')} onBack={() => navigate(-1)} theme={C} />
        <div
          className="overflow-y-auto px-5 pt-[70px] text-sm leading-[1.65]"
          style={{ height: 'calc(100% - 70px)', paddingBottom: '32px', color: C.text }}
        >
          {pricingQuery.isPending ? (
            <p>{t('exchangeCalc.loading', '正在加载最新汇率…')}</p>
          ) : pricingQuery.isError || lines.length === 0 ? (
            <p>{t('exchangeCalc.unavailable', '汇率暂时无法获取，请稍后重试。')}</p>
          ) : (
            lines.map((line, index) => (
              <p key={index} className={index > 0 ? 'mt-4' : undefined}>
                {line}
              </p>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
